// TODO fix direct url link to https://juno.localhost/site/Notifications

import './style.scss';
import { FontAwesomeConfigurations } from '../../../../utils/Configuration/FontAwesomeConfiguration';
import { Accessibility } from '../../../../utils/Accessibility/Accessibility';
import ReactComponent from '../../../ReactComponent';
import { NotificationModuleProps } from '../../../modules/NotificationModule';
export default class NotificationPanel extends BaseListPanel {
  mDiv: JQuery<HTMLElement>;
  mConstructorParams: any;
  mPerPage = 20;
  mLoadMoreOffset: 200;
  mLastScrollPosition: 0;
  mLoadMore: LoadMore;
  mPullToRefresh: PullToRefresh;
  mPageNum: number;

  private _notificationModules = [];

  constructor() {
    super();
  }

  initialize(aConstructorParams) {
    this.mConstructorParams = aConstructorParams;
    super.initialize(aConstructorParams);

    this._addButtons();
    this._addEventListeners();
  }

  private _addEventListeners() {
    Accessibility.clickAndKeypress(this.mDiv.find('.panel_close'), () => {
      this.onHide();
    });

    Accessibility.clickAndKeypress(this.mDiv.find('.mobile_close'), () => {
      this.onHide();
    });

    Accessibility.clickAndKeypress(this.mDiv.find('.panel_content'), event => {
      event.stopPropagation();
      Accessibility.actionMenuOpen = false;
    });

    Accessibility.clickAndKeypress(this.mDiv.find('.panel_body'), event => {
      event.stopPropagation();
    });

    Accessibility.clickAndKeypress(this.mDiv, () => {
      // this stops the panel from closing if we had an action menu open
      if (Accessibility.actionMenuOpen == true) {
        Accessibility.actionMenuOpen = false;
        return;
      }
      this.onHide();
    });

    App.INSTANCE.addEventListener(
      AppRouter.ROUTEREVENT_ONROUTERBEFORE,
      () => {
        if (this.mConstructorParams.onHide != null) {
          this.mConstructorParams.onHide(this);
        }
      },
      this,
    );
    Accessibility.clickAndKeypress(this.mDiv.find('.subtitle'), () => {
      this._showPrefsPanel();
    });
    PubNubCenter.INSTANCE?.addEventListener(
      PubNubCenter.ON_SOCIAL_NOTIFICATION,
      (event, message) => {
        if (message.message.notifiee_id != App.INSTANCE.CurrentUser.Id) {
          return;
        }
        if (message.channel == App.INSTANCE.CurrentUser.ChatRoom) {
          super.onRefresh(false);
        }
      },
      this,
    );
  }

  private _showPrefsPanel() {
    if (this.mConstructorParams.onHide != null) {
      this.mConstructorParams.onHide(this);
    }
    let url = App.INSTANCE.appRouter.generate('navigate.notificationpreferences');
    App.INSTANCE.route(url);
  }

  private _addButtons() {
    let clearBtn = new BaseCSSButton();
    clearBtn.initialize({
      textStyle: '',
      buttonStyle: 'standard_button_outline',
      text: CrowdHub_App.LANG.MARK_ALL_NOTIFICATIONS_READ,
      shouldHaveHoverEffect: true,
      click: () => {
        App.INSTANCE.mApi.Request(
          '../custom_api/api_Services_Notifications.php',
          {
            api: 'api_mark_notifications_read',
            notifications: 'all',
          },
          success => {
            super.reset();
            super.onRefresh(true);
            App.INSTANCE.loadNotificationCount();
          },
          error => {
            console.error(error);
          },
        );
      },
      scope: this,
      showLoader: true,
      container: this.mDiv.find('.panel_header_buttons'),
    });
  }

  private _generateReactNotificationModuleProps(aNotification): NotificationModuleProps {
    // keep the preview under 100 characters
    let descriptionPreview = aNotification.notification_message.slice(0, 100);
    if (descriptionPreview.length == 100) {
      descriptionPreview += '...';
    }
    // generate the date
    // TODO generate like "1 min ago"
    let datePart = moment.utc(aNotification.notification_date).local().format('MMM DD, YYYY');
    let timePart = moment.utc(aNotification.notification_date).local().format('hh:mma');
    aNotification.notification_date = `${datePart} at ${timePart}`;

    let contentName = aNotification.content_name ?? aNotification.notification_message;
    aNotification.notification_icon = null;
    descriptionPreview = `"${descriptionPreview}"`;
    // generating correct data to show here
    switch (Number(aNotification.notification_alert_type)) {
      case 0: // meaning notification_alert_type is null
      case CrowdHub_App.NOTIFICATION_TYPE_TARGETED:
        aNotification.notification_title = `<b>${aNotification.notification_title}</b>`;
        descriptionPreview = `${contentName}`;
        aNotification.notification_icon = FontAwesomeConfigurations.ICON_BULLHORN_SOLID;
        break;
      case CrowdHub_App.NOTIFICATION_TYPE_FORUM_NEW_TOPIC:
        aNotification.notification_title = `<b>${CrowdHub_App.LANG.NEW_FORUM_TOPIC_NOTIFICATION_HEADER}</b>`;
        descriptionPreview = `${CrowdHub_App.LANG.NEW_FORUM_TOPIC_NOTIFICATION_MESSAGE} <b>${contentName}</b>`;
        aNotification.notification_icon = FontAwesomeConfigurations.ICON_BULLHORN_SOLID;
        break;
      case CrowdHub_App.NOTIFICATION_TYPE_LMS_USER_ENROLLED:
        aNotification.notification_title = `<b>${CrowdHub_App.LANG.LMS_ENROLLMENT_UPDATE_NOTIFICATION_HEADER}</b>`;
        descriptionPreview = `${CrowdHub_App.LANG.LMS_ENROLLED_NOTIFICATION_MESSAGE} <b>"${contentName}"</b>`;
        aNotification.notification_icon = FontAwesomeConfigurations.ICON_MEMO_CIRCLE_INFO_LIGHT;
        break;
      case CrowdHub_App.NOTIFICATION_TYPE_LMS_USER_WAITLISTED:
        aNotification.notification_title = `<b>${CrowdHub_App.LANG.LMS_ENROLLMENT_UPDATE_NOTIFICATION_HEADER}</b>`;
        descriptionPreview = `${CrowdHub_App.LANG.LMS_WAITLISTED_NOTIFICATION_MESSAGE} <b>"${contentName}"</b>`;
        aNotification.notification_icon = FontAwesomeConfigurations.ICON_MEMO_CIRCLE_INFO_LIGHT;
        break;
      case CrowdHub_App.NOTIFICATION_TYPE_FORUM_REPLY:
      case CrowdHub_App.NOTIFICATION_TYPE_FEED_REPLY:
      case CrowdHub_App.NOTIFICATION_TYPE_FORUM_COMMENT_REPLY:
      case CrowdHub_App.NOTIFICATION_TYPE_FEED_COMMENT_REPLY:
        contentName = aNotification.content_description;
        aNotification.notification_title = `<b>${aNotification.author_name}</b> ${aNotification.notification_title} <b>${contentName}</b>`;
        descriptionPreview = `"${descriptionPreview}"`;
        break;
      case CrowdHub_App.NOTIFICATION_TYPE_EXTERNAL_URL:
        // notification.image is being used for an expire date string
        // check if the expire date is in the past, if so change the notification text
        let expireTime;
        switch (contentName) {
          case 'My Sessions PDF':
            expireTime = '1 hour';
            break;
          case 'Learner Transcripts':
            expireTime = '1 week';
            break;
          default:
            expireTime = '1 hour';
            break;
        }
        const now = moment.utc().format('YYYY-MM-DD HH:mm:ss A');

        if (aNotification.notification_image != '' && aNotification.notification_image < now) {
          // notification has expired
          aNotification.notification_title = `<b>${contentName}</b> download has expired.`;
          descriptionPreview = `Sorry, this download is only available for  ${expireTime} after a request is made.`;
          aNotification.notification_url = '';
          aNotification.notification_icon = FontAwesomeConfigurations.ICON_XMARK_TO_SLOT;
        } else {
          aNotification.notification_icon = FontAwesomeConfigurations.ICON_ARROW_DOWN_TO_BRACKET;
          descriptionPreview = `Click this notification to begin your download (this link expires in ${expireTime}).`;
        }
        break;
      default:
        aNotification.notification_title = `<b>${aNotification.author_name}</b> ${aNotification.notification_title} <b>${contentName}</b>`;
        break;
    }

    let moduleParams = {
      onApiRequest: (aUrl, aVars) => {
        return new Promise<null>((resolve, reject) => {
          App.INSTANCE.mApi.Request(
            aUrl,
            aVars,
            success => {
              resolve(success);
            },
            error => {
              console.error(error);
              reject(error);
            },
          );
        });
      },
      onClick: () => {
        App.INSTANCE.mMessageController.hide(this, UITransitions.slideUp);
      },
      onPrefs: this._showPrefsPanel.bind(this),
      description: descriptionPreview,
      id: aNotification.notification_id,
      image: aNotification.notification_image == '' ? aNotification.author_image : aNotification.notification_image,
      icon: aNotification.notification_icon,
      isRead: aNotification.notification_is_read == '1' || aNotification.notification_is_read == 'true' ? true : false,
      time: aNotification.notification_date,
      title: aNotification.notification_title,
      url: aNotification.notification_url,
      type: aNotification.notification_alert_type,
      containerRef: { current: this.mDiv.find('.panel_body')[0] as HTMLDivElement },
    };

    return moduleParams;
  }

  private _addNotifications(aNotifications) {
    let totalRead = 0;
    let panelBodyDiv = this.mDiv.find('.panel_body');
    this._notificationModules = [];

    aNotifications.forEach(notification => {
      if (notification.notification_is_read == '1' || notification.notification_is_read == 'true') {
        totalRead++;
      }
      panelBodyDiv.append($(HGEN.tree({ style: `notification_row_${notification.notification_id}` })));
      let notificationProps = this._generateReactNotificationModuleProps(notification);
      let notificationModule = new ReactComponent();
      notificationModule.inject(
        'NotificationModule',
        panelBodyDiv.find(`.notification_row_${notification.notification_id}`),
        notificationProps,
      );
      this._notificationModules.push(notificationModule);
    });
    if (this.mPageNum == 0) {
      if (totalRead == aNotifications.length) {
        this.mDiv.find('.panel_header_buttons').hide();
      } else {
        this.mDiv.find('.panel_header_buttons').show();
      }
    }
  }

  getUrl() {
    return '../custom_api/api_Services_Notifications.php';
  }

  getVars() {
    return {
      api: 'api_get_notifications_for_user',
      page_num: this.mPageNum,
      per_page: this.mPerPage,
    };
  }

  getStruct(): JQuery<HTMLElement> {
    return {
      style: 'notification_panel',
      children: [
        {
          style: 'panel_container',
          children: [
            {
              style: 'panel_close',
              interior: `Close ${HGEN.faicon({ style: FontAwesomeConfigurations.ICON_XMARK })}`,
            },
            {
              style: 'panel_content device_padding_topinset',
              children: [
                {
                  style: 'panel_header',
                  children: [
                    {
                      style: 'panel_title',
                      children: [
                        {
                          style: 'mobile_close',
                          interior: HGEN.faicon({ style: FontAwesomeConfigurations.ICON_CHEVRON_DOWN }),
                        },
                        { style: 'title', interior: 'Notifications' },
                        {
                          style: 'subtitle',
                          children: [
                            {
                              style: 'panel_icon',
                              interior: HGEN.faicon({ style: FontAwesomeConfigurations.ICON_GEAR_SOLID }),
                            },
                            { style: '', interior: App.INSTANCE.isPhone() ? 'Preferences' : 'Update Preferences' },
                          ],
                        },
                      ],
                    },
                    { style: 'panel_header_buttons' },
                  ],
                },
                { style: 'panel_body' },
                { id: 'no_results_container', children: [{ style: 'noresults_text' }] },
                { style: 'panel_footer' },
              ],
            },
          ],
        },
      ],
    };
  }

  onData(aData) {
    let aNotificationList = aData['notifications'];
    if (!aNotificationList || aNotificationList.length == 0) {
      super.showNoResults(true);
      this.mDiv.find('.panel_header_buttons').hide();
      return;
    }
    if (this.mLoadMore != null) {
      this.mLoadMore.loadComplete(aNotificationList.length >= this.mPerPage);
    }
    if (this.mPullToRefresh != null) {
      this.mPullToRefresh.stopRefreshing();
    }
    this._addNotifications(aNotificationList);
  }

  onHide() {
    if (this.mConstructorParams.onHide != null) {
      this.mConstructorParams.onHide(this);
    }
    App.INSTANCE.safelyGoBack();
  }

  setupLoadMore() {
    this.mLoadMore = new LoadMore();
    this.mLoadMore.initialize({
      offset: this.mLoadMoreOffset,
      parent: this.mDiv.find('.panel_body'),
      div: this.mDiv.find('.panel_body'),
      container: this.mDiv.find('.panel_body'),
      onLoadMore: () => {
        super.onLoadMore();
      },
      loadingIcon: App.INSTANCE.getAssetsSrc(Resources.resources.PRELOADER_ICONTINY.src),
    });
  }

  setupPullToRefresh() {
    this.mPullToRefresh = new PullToRefresh();
    this.mPullToRefresh.initialize({
      div: this.mDiv.find('.panel_body'),
      container: this.mDiv,
      onWillRefresh: () => {
        super.reset();
        super.onRefresh(true);
      },
      onRefresh: () => {
        console.log('PullToRefresh onRefresh');
        super.onRefresh(true);
      },
      loadingIcon: App.INSTANCE.getAssetsSrc(Resources.resources.PRELOADER_ICONTINY.src),
    });
  }

  listContainer() {
    return this.mDiv.find('.panel_body');
  }

  onTransitionIn() {
    if (this.mLastScrollPosition != null) {
      this.mDiv.find('.panel_body').scrollTop(this.mLastScrollPosition);
    }
    this.setupLoadMore();
    this.setupPullToRefresh();
  }

  onTransitionOut() {
    this.mLastScrollPosition = this.mDiv.find('.panel_body').scrollTop();
    App.INSTANCE.removeEventListenerByScope(AppRouter.ROUTEREVENT_ONROUTERBEFORE, this);
    this._notificationModules.forEach(reactModule => {
      reactModule.destroy();
    });
  }
}
